module.exports = "../../static/img/od.2ea9234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/od.png
// module id = 3xuw
// module chunks = 1